'use strict';

/**
 * Инциализация swiper
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

let presets = {
	'default': {
		loop: true,
		pagination: {
			el: '.js-default-slider-pagination',
			type: 'bullets',
			clickable: true,
			bulletClass: 'default-slider__bullet',
			bulletActiveClass: 'default-slider__bullet--active'
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function () {
				window.lazyLoad.observe();
			}
		}
	},
	review: {
		loop: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		autoHeight: true,
		preloadImages: false,
		lazy: {
			loadPrevNext: true
		},
		pagination: false,
		simulateTouch: false,
		allowSwipeToNext: false,
		allowSwipeToPrev: false,
		on: {
			lazyImageLoad: function () {
				this.update();
			}
		}
	},
	calculator: {
		loop: false,
		allowTouchMove: false,
		speed: 500,
		autoHeight: true,
		passiveListeners: false,
		lazy: {
			loadPrevNext: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			init: function () {
				let $before = $('.before-load');
				$before.removeClass('before-load');
				this.update();

				$('.js-swiper-next').on('click', function () {
					$(this).find('input').prop('checked', true);
				});
			}
		}
	},
	'review-image': {
		loop: true,
		lazy: {
			loadPrevNext: true
		},
		pagination: {
			el: '.js-default-slider-pagination',
			type: 'bullets',
			bulletClass: 'default-slider__bullet',
			bulletActiveClass: 'default-slider__bullet--active',
			clickable: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function () {
				if (window.Gapi['review']) {
					window.Gapi['review'].slideTo(this.activeIndex);
				}
			}
		}
	},
	'projects': {
		loop: true,
		lazy: {
			loadPrevNext: true
		},
		pagination: {
			el: '.js-projects-slider-pagination',
			type: 'bullets',
			bulletClass: 'projects-slider__dot',
			bulletActiveClass: 'projects-slider__dot--active',
			clickable: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		on: {
			slideChange: function () {
				let image = $(".first-screen__image"),
					src = this.$wrapperEl.find('.swiper-slide-active').next().data('src');
				image.css({'opacity': '0.9', 'transform': 'scale(1.02)'}).attr('src', src);

				setTimeout(function (){
					image.css({'opacity': '1', 'transform': 'scale(1)'})
				}, 500)
			},
		}
	},
	'clients': {
		slidesPerView: 'auto',
		breakpoints: {
			640: {
				slidesPerView: 7,
			}
		}
	},
	'industries': {
		loop: true,
		lazy: {
			loadPrevNext: true
		}
	},
	'industries-clutch': {
		loop: false,
		allowTouchMove: false,
		speed: 500,
		autoHeight: true,
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		scrollbar: {
			el: ".swiper-scrollbar",
		}
	},
	'industries-slider': {
		slidesPerView: 1,
		loop: false,
		allowTouchMove: true,
		speed: 500,
		autoHeight: true,
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		}
	},
	'books': {
		slidesPerView: 3,
		loop: false,
		allowTouchMove: true,
		autoplay: {
			delay: 2500,
		},
		speed: 1000,
		autoHeight: true,
		preloadImages: false,
		lazy: {
			loadPrevNext: true
		},
		navigation: {
			nextEl: '.js-swiper-next',
			prevEl: '.js-swiper-prev'
		},
		pagination: false,
		simulateTouch: true,
		allowSwipeToNext: false,
		allowSwipeToPrev: false,
		breakpoints: {
			732: {
				slidesPerView: 1,
				spaceBetween: 15
			},
			1980: {
				slidesPerView: 3,
				spaceBetween: 15,
				autoplay: false
			}
		}
	}
};

/**
 * @param {string} [selector]- поиск элементов по селектору
 * @sourceCode
 */
function swiper (selector) {
	window.Gapi = {};
	$(selector).each(function () {
		let $this = $(this);
		let preset = $this.data('preset') || 'default';
		let initWidth = $this.data('init-width');
		if (!initWidth || (initWidth && $(window).width() < +initWidth)) {
			window.Gapi[preset] = new window.Swiper(this, presets[preset]);// eslint-disable-line no-new
		} else {
			$this.find('.swiper-lazy-preloader').remove();
			$this.find('.swiper-lazy').each(function () {
				let data = $(this).data('src');
				$(this).attr('src', data);
			});
		}
	});
}

function swiperInput () {
	let $swiper = $('.js-swiper');
	let $slid = $swiper.find('.swiper-slide');
	if ($swiper.length) {
		if ($slid.length > 1) {
			require.ensure([], () => {
				window.Swiper = require('swiper/dist/js/swiper.js');
				require('_vendors/swiper.css');
				swiper('.js-swiper');
			}, 'swiper');
		} else if ($slid.length === 1) {
			$swiper.addClass('is-one');
			$slid.css('background-image', `url(${$slid.data('background')})`);
		}
	}
}

export default swiperInput;



// WEBPACK FOOTER //
// ./src/js/_modules/swiper.js